import du from '@/utils/statistics'
import cache from '@/utils/authorityCache'
import { getToken } from '@/utils/authority'
import * as Api from '@/api/travel'

let payload = {
  id: '',
  action: '',
  label: '',
  time: 0,
}

export function stopTime() {
  const { id, action, label, time } = payload
  du.trackEvent(id, action, label, Math.floor((new Date().valueOf() - time) / 1000))
}
export async function create(data = {}, key = 'hotel') {
  let list = cache.get()
  let date = new Date()
  let month = date.getMonth() + 1
  let day = date.getDate()
  let hour = date.getHours()
  let minute = date.getMinutes()
  let second = date.getSeconds()
  let template = {
    hotel: `${month}月${day}日，${hour}时${minute}分${second}秒，访问了「${data.name}」`,
    place: `${month}月${day}日，${hour}时${minute}分${second}秒，访问了「${data.name}酒店」-「${data.hall_name}场地」`,
    product: `${month}月${day}日，${hour}时${minute}分${second}秒，访问了「${data.tag}类型」方案套餐「${data.name}」`,
  }
  let str = template[key]
  if (!getToken()) {
    cache.set(str)
  } else {
    list.push(str)
    list.slice(0, 100)
    await Api.track(list.join('\n'))
    cache.clear()
  }
}

export function startTime({ action = {}, data = {}, key = 'hotel' }) {
  payload = {
    ...action,
    time: new Date().valueOf(),
  }
  window.onbeforeunload = stopTime
  create(data, key)
}

export function destoryTime() {
  window.onbeforeunload = function () { }
  stopTime()
}
